import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'sonner';

import { QueryEntity } from '../types';
import { APIBaseChronos } from '@/api/hosts';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

export const useDeleteAllPermissionOverrides = (matterId: string) => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  return useMutation<void, Error>({
    mutationFn: async () => {
      const fetchConfig = getFetchConfig({
        method: FetchMethod.DELETE,
      });
      const response = await fetch(`${APIBaseChronos}/api/matters/${matterId}/permission-overrides`, fetchConfig);
      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message ?? 'Failed to reset Matter-level permissions');
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries([QueryEntity.PermissionOverrides, { matterId }]);
      queryClient.invalidateQueries([QueryEntity.Matter, { matterId }]);
      toast.success('All Matter-level permission overrides removed');
    },
    onError: () => {
      toast.error('Failed to reset Matter-level permissions');
    },
  });
};
